<template>
  <Card
    hasNoBorder
  >
    <HeadingSmall>
      Device Details
    </HeadingSmall>
    <ParagraphBody>
      <div :class="[$style.grid, $style.marginTop]">
        <div :class="[$style.leftHalf, $style.marginTopSmall]">
          JumpCloud Device Name:
        </div>
        <div :class="$style.rightHalf">
          <div :class="$style.gridContainer">
            <div :class="$style.gridItem">
              <InputText
                v-model="item.displayName"
                :class="$style.lightBackground"
                :isDisabled="isDeviceNameDisabled"
              />
            </div>
            <div :class="$style.gridItem">
              <IconButton
                hasOutline
                icon="edit"
                iconPosition="right"
                text="edit"
                type="secondary"
                @click="handleDeviceNameEdit"
              />
            </div>
          </div>
        </div>
      </div>
      <div :class="[$style.grid, $style.marginTopNegativeSmall]">
        <div :class="[$style.leftHalf, $style.marginTopSmall]">
          Descripton:
        </div>
        <div :class="$style.rightHalf">
          <div :class="$style.gridContainer">
            <div :class="$style.gridItem">
              <InputText
                v-model="item.description"
                :class="$style.lightBackground"
                :isDisabled="isDescriptionDisabled"
              />
            </div>
            <div :class="$style.gridItem">
              <IconButton
                hasOutline
                icon="edit"
                iconPosition="right"
                text="edit"
                type="secondary"
                @click="handleDescriptionEdit"
              />
            </div>
          </div>
        </div>
      </div>
      <div :class="[$style.grid, $style.marginTopNegativeSmall]">
        <div :class="$style.leftHalf">
          Android Device Name:
        </div>
        <div :class="$style.rightHalf">
          {{ androidDeviceName }}
        </div>
      </div>
      <div :class="[$style.grid, $style.marginTop]">
        <div :class="$style.leftHalf">
          Last Contact:
        </div>
        <div :class="$style.rightHalf">
          {{ getLastContact() }}
        </div>
      </div>
      <div :class="[$style.grid, $style.marginTop]">
        <div :class="$style.leftHalf">
          JumpCloud System ID:
        </div>
        <div :class="$style.rightHalf">
          {{ item.id }}
        </div>
      </div>
    </ParagraphBody>
  </Card>
</template>

<script>
import {
  Card,
  HeadingSmall,
  IconButton,
  InputText,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import { ItemTypeConsts, StoreModelMap } from 'client/util/Constants';
import { mapState } from 'vuex';
import moment from 'moment';

const systemStoreModel = StoreModelMap[ItemTypeConsts.system];

export default {
  name: 'AndroidDeviceDetailsInfo',

  components: {
    Card,
    HeadingSmall,
    IconButton,
    InputText,
    ParagraphBody,
  },

  props: {
    androidDeviceName: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    isDescriptionDisabled: true,
    isDeviceNameDisabled: true,
  }),

  computed: {
    ...mapState(systemStoreModel, {
      item: state => state.item,
    }),
  },

  methods: {
    getLastContact() {
      return moment(this.item.lastContact).utc().fromNow();
    },

    handleDescriptionEdit() {
      this.isDescriptionDisabled = false;
    },

    handleDeviceNameEdit() {
      this.isDeviceNameDisabled = false;
    },
  },
};
</script>

<style module>
.gridContainer {
  display: grid;
  grid-template-columns: auto 8rem;
}

.gridItem {
  text-align: right;
}

.marginTop {
  margin-top: var(--jc-spacer-medium);
}

.marginTopSmall {
  margin-top: var(--jc-spacer-x-small);
}

.marginTopNegativeSmall {
  margin-top: var(--jc-spacer-negative-small);
}

.lightBackground {
  background-color: var(--jc-background-light) !important;
}

.lightBackground > div > label > span > span {
  background-color: var(--jc-background-light) !important;
}

.rightHalf {
  flex: 1;
  text-align: end;
}

.leftHalf {
  flex: 1;
  font-style: normal;
  font-weight: 600;
  text-align: start;
}

.grid {
  display: flex;
}
</style>
